import { api } from '../../../api';
import { PddDocument } from '../../../types';

interface ListPDDResponse {
  data: PddDocument[];
  limit: number;
  skip: number;
  total: number;
}

const parseStatusFromTab = (text: string | undefined | null) => {
  if (!text) return undefined;
  switch (text) {
    case 'in-progress':
      return 'IN_PROGRESS';
    case 'completed':
      return 'COMPLETED';
    case 'archived':
      return 'ARCHIVED';
    default:
      return undefined;
  }
};

export const fetchPDD = async (page: number, limit: number, pddStatus?: string | null) => {
  const status = parseStatusFromTab(pddStatus);
  const response = await api.get<ListPDDResponse>(
    `/documents?skip=${page - 1}&limit=${limit}${status ? `&status=${status}` : ''}`,
  );
  return response.data;
};
